
export class ProvisionChange {

	Type: string;
	Family: string;
	FamilyDescription: string;
	FromExecution: string;
	FromExecutionDescription: string;
	ToExecution: string;
	ToExecutionDescription: string;
	SpisaInfoExists: boolean;
	IsInCSpec: boolean;

	constructor(type?: string, family?: string, familyDescription?: string, fromExecution?: string, fromExecutionDescription?: string, toExecution?: string, toExecutionDescription?: string) {
		this.Type = type;
		this.Family = family;
		this.FamilyDescription = familyDescription;
		this.FromExecution = fromExecution;
		this.FromExecutionDescription = fromExecutionDescription;
		this.ToExecution = toExecution;
		this.ToExecutionDescription = toExecutionDescription;
	}

	static fromJSON(data: any): ProvisionChange {
		let provisionChange = new ProvisionChange();
		if (data != null) {
			provisionChange.Type = data['Type'];
			provisionChange.Family = data['Family'];
			provisionChange.FamilyDescription = data['FamilyDescription'];
			provisionChange.FromExecution = data['FromExecution'];
			provisionChange.FromExecutionDescription = data['FromExecutionDescription'];
			provisionChange.ToExecution = data['ToExecution'];
			provisionChange.ToExecutionDescription = data['ToExecutionDescription'];
		}
		return provisionChange;
	}
}
